import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class FaqV1 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="ltn__faq-area mb-100">
            <div className="container">
            <div className="row">
                <div className="col-lg-8">
                <div className="ltn__faq-inner ltn__faq-inner-2">
                    <div id="accordion_2">
                    {/* card */}
                    <div className="card">
                        <h6 className="collapsed ltn__card-title" data-bs-toggle="collapse" data-bs-target="#faq-item-2-1" aria-expanded="false">
                        How do I book a plot with AVS Enterprises?
                        </h6>
                        <div id="faq-item-2-1" className="collapse" data-bs-parent="#accordion_2">
                        <div className="card-body">
                            <p>Booking a plot is simple. Just contact our sales team or request a site visit via our website or phone. Once you choose your plot, we guide you through the documentation, token advance, and legal verification. Final registration is handled smoothly with full transparency.</p>
                        </div>
                        </div>
                    </div>
                    {/* card */}
                    <div className="card">
                        <h6 className="ltn__card-title" data-bs-toggle="collapse" data-bs-target="#faq-item-2-2" aria-expanded="true"> 
                        What documents do I receive after purchase?
                        </h6>
                        <div id="faq-item-2-2" className="collapse show" data-bs-parent="#accordion_2">
                        <div className="card-body">
                            <p>You’ll receive the Sale Deed, Encumbrance Certificate, Approved Layout Plan, and Property Tax details. All our projects are B-Katha or DC converted with clear titles, ensuring complete legal security for buyers.</p>
                        </div>
                        </div>
                    </div>                          
                    {/* card */}
                    <div className="card">
                        <h6 className="collapsed ltn__card-title" data-bs-toggle="collapse" data-bs-target="#faq-item-2-3" aria-expanded="false">
                        Are AVS layouts approved by authorities?
                        </h6>
                        <div id="faq-item-2-3" className="collapse" data-bs-parent="#accordion_2">
                        <div className="card-body">
                            <p>Yes. Every AVS project is legally approved — either by the CMC, BDA, or local governing bodies, depending on location. We share all approvals during the site visit and ensure clear title before booking.</p>
                        </div>
                        </div>
                    </div>
                    {/* card */}
                    <div className="card">
                        <h6 className="collapsed ltn__card-title" data-bs-toggle="collapse" data-bs-target="#faq-item-2-4" aria-expanded="false">
                        Can I build a home immediately after purchase?
                        </h6>
                        <div id="faq-item-2-4" className="collapse" data-bs-parent="#accordion_2">
                        <div className="card-body">
                            <p>Yes, you can begin construction after registration. Our sites are ready-to-build with roads, electricity, drainage, and water connections. We also assist with villa design and construction if needed.</p>
                        </div>
                        </div>
                    </div>
                    {/* card */}
                    <div className="card">
                        <h6 className="collapsed ltn__card-title" data-bs-toggle="collapse" data-bs-target="#faq-item-2-5" aria-expanded="false">
                        What makes AVS plots a good investment?
                        </h6>
                        <div id="faq-item-2-5" className="collapse" data-bs-parent="#accordion_2">
                        <div className="card-body">
                            <p>AVS layouts are located in high-growth areas near metro lines, highways, and urban expansion zones. With legal clarity, gated security, and limited supply, our plots offer strong resale and rental value.</p>
                        </div>
                        </div>
                    </div>
                    {/* card */}
                    <div className="card">
                        <h6 className="collapsed ltn__card-title" data-bs-toggle="collapse" data-bs-target="#faq-item-2-6" aria-expanded="false">
                        Can I visit the site before deciding?
                        </h6>
                        <div id="faq-item-2-6" className="collapse" data-bs-parent="#accordion_2">
                        <div className="card-body">
                            <p>Yes. We offer weekend site visits with AVS experts. You’ll get a personalized plot walkthrough and full explanation of amenities, pricing, and legal details.</p>
                        </div>
                        </div>
                    </div>
                    {/* card */}
                    <div className="card">
                        <h6 className="collapsed ltn__card-title" data-bs-toggle="collapse" data-bs-target="#faq-item-2-7" aria-expanded="false">
                        How secure are your layouts?
                        </h6>
                        <div id="faq-item-2-7" className="collapse" data-bs-parent="#accordion_2">
                        <div className="card-body">
                            <p>All AVS projects are gated communities with 24/7 surveillance, well-lit roads, boundary fencing, and controlled entry for enhanced safety and privacy.</p>
                        </div>
                        </div>
                    </div>
                    {/* card */}
                    <div className="card">
                        <h6 className="collapsed ltn__card-title" data-bs-toggle="collapse" data-bs-target="#faq-item-2-8" aria-expanded="false">
                        What infrastructure and amenities are included?
                        </h6>
                        <div id="faq-item-2-8" className="collapse" data-bs-parent="#accordion_2">
                        <div className="card-body">
                            <p>Our layouts come with concrete roads (CC), underground cabling, solar lighting, water supply, drainage systems, and landscaping. Many also include parks, play zones, and clubhouse access.</p>
                        </div>
                        </div>
                    </div>
                    {/* card */}
                    <div className="card">
                        <h6 className="collapsed ltn__card-title" data-bs-toggle="collapse" data-bs-target="#faq-item-2-9" aria-expanded="false">
                        Can I verify documents before I pay?
                        </h6>
                        <div id="faq-item-2-9" className="collapse" data-bs-parent="#accordion_2">
                        <div className="card-body">
                            <p>Of course. We provide layout approvals, land titles, and ownership documents during the site visit. We recommend you consult your legal advisor before finalizing the booking.</p>
                        </div>
                        </div>
                    </div>
                    {/* card */}
                    <div className="card">
                        <h6 className="collapsed ltn__card-title" data-bs-toggle="collapse" data-bs-target="#faq-item-2-10" aria-expanded="false">
                        Do you offer loan or EMI options?
                        </h6>
                        <div id="faq-item-2-10" className="collapse" data-bs-parent="#accordion_2">
                        <div className="card-body">
                            <p>Yes. AVS works with approved banks and NBFCs to help eligible buyers get financing. We assist you through the entire loan application and documentation process.</p>
                        </div>
                        </div>
                    </div>
                    {/* card */}
                    <div className="card">
                        <h6 className="collapsed ltn__card-title" data-bs-toggle="collapse" data-bs-target="#faq-item-2-11" aria-expanded="false">
                        What happens after I buy the plot?
                        </h6>
                        <div id="faq-item-2-11" className="collapse" data-bs-parent="#accordion_2">
                        <div className="card-body">
                            <p>After registration, the plot is fully yours. You can either hold it for appreciation, start construction, or reach out to us for custom building support. We also help with name transfer, tax guidance, and resale services if needed.</p>
                        </div>
                        </div>
                    </div>
                    {/* card */}
                    <div className="card">
                        <h6 className="collapsed ltn__card-title" data-bs-toggle="collapse" data-bs-target="#faq-item-2-12" aria-expanded="false">
                        Are there any hidden charges?
                        </h6>
                        <div id="faq-item-2-12" className="collapse" data-bs-parent="#accordion_2">
                        <div className="card-body">
                            <p>No. All our pricing is transparent and upfront. We clearly explain all costs including registration, taxes, and maintenance (if applicable) before booking.</p>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div className="need-support text-center mt-100">
                    <h2>Still need help? Reach out to support :</h2>
                    <div className="btn-wrapper mb-30 go-top">
                        <Link to="/contact" className="theme-btn-1 btn" style={{ borderRadius: '10px'}}>Contact Us</Link>
                    </div>
                    <h3>
                     Phone: <a href="tel:+919108492343">+91 9108492343</a> <br />
                     </h3>
                    </div>
                </div>
                </div>
                <div className="col-lg-4">
                <aside className="sidebar-area ltn__right-sidebar">
                    {/* Newsletter Widget */}
                    <div className="widget ltn__form-widget">
						<h4 className="ltn__widget-title ltn__widget-title-border-2">Drop Messege For Book</h4>
						<form action="#">
							<input type="text" name="yourname" placeholder="Your Name*" />
							<input type="text" name="youremail" placeholder="Your e-Mail*" />
							<textarea name="yourmessage" placeholder="Write Message..." defaultValue={""} />
							<button type="submit" className="btn theme-btn-1" style={{ borderRadius: '10px'}}>Send Messege</button>
						</form>
					</div>
                </aside>
                </div>
            </div>
            </div>
        </div>
  
        }
}

export default FaqV1